import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var WaitingSVG = function WaitingSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M26,26H25c0-4.45-2-8.27-5-10,2.93-1.73,5-5.55,5-10h1a2,2,0,0,0,0-4H6A2,2,0,0,0,6,6H7c0,4.45,2,8.27,5,10C9,17.73,7,21.55,7,26H6a2,2,0,0,0,0,4H26a2,2,0,0,0,0-4ZM11,12H21c0,2-4.5,3-5,3S11,14,11,12ZM10,26c0-3,4.5-7,6-7s6,4,6,7Z"
  }));
};
WaitingSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(WaitingSVG);